import BaseTibbit from '@appblocks/codegeneration/Tibbits/_BaseTibbit';
import Tibbits from '@appblocks/codegeneration/Tibbits/index';
import {
    CodeBlock, BlockType, SettingType, ValidationMessage, ValidationMessageType,
} from '@appblocks/codegeneration/types';

export default class Tibbit_08 extends BaseTibbit {
    constructor() {
        super();
        this.id = 'tibbit_08';
        this.name = 'Tibbit 08';
        const settings = [
            {
                id: 'NAME',
                name: 'Name',
                settingType: SettingType.NAME,
                required: true,
                default: '',
            },
            {
                id: 'MODE',
                name: 'Mode',
                settingType: SettingType.OPTION,
                required: true,
                default: 'PL_SER_MODE_WIEGAND',
                options: [
                    {
                        name: 'Wiegand',
                        value: 'PL_SER_MODE_WIEGAND',
                    },
                    {
                        name: 'Clock/Data',
                        value: 'PL_SER_MODE_CLOCKDATA',
                    },
                ],
            },
            {
                id: 'TXBUF',
                name: 'TX Buffer Pages',
                settingType: SettingType.BUFFER,
                required: true,
                default: '1',
            },
            {
                id: 'RXBUF',
                name: 'RX Buffer Pages',
                settingType: SettingType.BUFFER,
                required: true,
                default: '1',
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    validate(): ValidationMessage[] {
        const errors: Array<ValidationMessage> = [];
        if (this.getSettingValue('NAME').trim() === '') {
            errors.push({ message: 'Please enter value for Name', messageType: ValidationMessageType.ERROR });
        }
        return errors;
    }

    getCodeBlocks() {
        const blocks: Array<CodeBlock> = [];

        if (this.project.runtime === 'simulator') {
            return [];
        }

        const NAME = `SER_${this.getSettingValue('NAME')}`;
        let template = `
    'Tibbit 08 setup on socket ${this.getSettingValue('SOCKET')}
    '================================================================
    ser.num=${NAME}
    ser.mode=${this.getSettingValue('MODE')}
    `;
        if (this.getSettingValue('MODE') === 'PL_SER_MODE_WIEGAND') {
            template += `
    'Set to Wiegand mode
    io.num=${Tibbits.getSocketPins(this.getSettingValue('SOCKET'), this.project.device.id)[2]}
    io.enabled=YES 
    io.state=HIGH
        `;
        } else {
            template += `
    'Set to clock/data mode
    io.num=${Tibbits.getSocketPins(this.getSettingValue('SOCKET'), this.project.device.id)[2]}
    io.enabled=YES 
    io.state=LOW
        `;
        }

        template += `
    ser.rxbuffrq(2)
    ser.txbuffrq(2)
    sys.buffalloc()
    ser.interchardelay=5
    ser.enabled=YES
    ser.rxclear()
    '-----------------------------------------------------------------`;


        blocks.push({
            location: 'boot',
            blockType: BlockType.CODE,
            template,
        });

        blocks.push({
            location: 'on_ser_data_arrival',
            id: `on_${NAME}_data_arrival`,
            template: `
if ser.num=${NAME} then
    dim ${NAME}_data as string = ser.getdata(255)
    '****on_${NAME}_data_arrival****'
end if`,
        });

        blocks.push({
            location: 'GLOBAL_CONSTS',
            blockType: BlockType.CODE,
            template: `
const ${NAME} = ${Tibbits.getSocket(this.getSettingValue('SOCKET'), this.project.device.id)?.serial}`,
        });


        return blocks;
    }
}
